import React, { PropsWithChildren } from 'react';
import {
  ListGroupItem,
  ListGroupItemText,
  ListGroupItemHeading,
  Button,
  ButtonGroup,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import { ConditionsCardLoading } from '.';

const ContainerItem = ({
  loading,
  children,
  disabled,
}: PropsWithChildren<{ loading?: boolean; disabled?: boolean }>) => (
  <ListGroupItem disabled={disabled}>
    {loading ? <ConditionsCardLoading /> : children}
  </ListGroupItem>
);

const CardNewItem = ({
  loading,
  disabled,
  newPath,
  title,
}: {
  loading?: boolean;
  disabled?: boolean;
  newPath?: string;
  title: string;
}) => (
  <ContainerItem loading={loading} disabled={disabled}>
    <ListGroupItemHeading>{title}</ListGroupItemHeading>
    <Button
      className="w-100"
      tag={Link}
      to={newPath || '/'}
      color={'primary'}
      disabled={disabled || loading}>
      New
    </Button>
  </ContainerItem>
);

const CardEditableItem = ({
  loading,
  disabled,
  created,
  title,
  viewPath,
  editPath,
}: {
  loading?: boolean;
  disabled?: boolean;
  editPath?: string;
  viewPath?: string;
  created: string;
  title: string;
}) => (
  <ContainerItem loading={loading} disabled={disabled}>
    <ListGroupItemHeading>{title}</ListGroupItemHeading>
    <ListGroupItemText className={'test'}>
      <strong>Date:</strong> {created}
    </ListGroupItemText>
    <ButtonGroup className="w-100">
      <Button
        tag={Link}
        to={editPath || '/'}
        color={'warning'}
        disabled={disabled || loading}>
        Edit
      </Button>
      <Button
        tag={Link}
        to={viewPath || '/'}
        color={'success'}
        disabled={disabled || loading}>
        View
      </Button>
    </ButtonGroup>
  </ContainerItem>
);

const CardItem = (props: {
  title: string;
  loading?: boolean;
  disabled?: boolean;
  newPath?: string;
  editPath?: string;
  viewPath?: string;
  created?: string;
}) =>
  props.editPath && props.viewPath && props.created ? (
    <CardEditableItem {...props} created={props.created} />
  ) : (
    <CardNewItem {...props} />
  );

export default CardItem;
